<app-layout-list-container
  [list]="fiches$ | async"
  [card]="cardItemFicheDePoste"
  [isNew]="false"
  [newNoDataTitle]="noDataTitle"
></app-layout-list-container>

<ng-template #cardItemFicheDePoste> Fiche de poste </ng-template>
